import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useParameters } from '@web/utils/src';
import { useAppDispatch } from '@/store/hooks';
import { setRetailer } from '@/store/slices/retailerSlice';
import { useRetailerQuery } from './RetailerPage/retailer.generated';

type RetailerParams = {
  retailerId: string;
};

const RetailerLayout = () => {
  const { retailerId } = useParameters<RetailerParams>();
  const dispatch = useAppDispatch();

  const [result] = useRetailerQuery({
    variables: {
      retailerId: retailerId,
    },
  });

  useEffect(() => {
    if (result.data?.retailer) {
      dispatch(setRetailer(result.data.retailer));
    }
  }, [dispatch, result.data?.retailer]);

  return <Outlet />;
};

export default RetailerLayout;
